import * as React from 'react'
import './searchFooter.scss'

interface SearchFooterProps {
    loading: boolean
    hasQuery: boolean
    totalResults: number
}

export function SearchFooter({ loading, hasQuery, totalResults }: SearchFooterProps): JSX.Element {
    return (
        <div className="global-search-footer">
            <span className="global-search-key-hint">
                <kbd>&uarr;</kbd>
                <kbd>&darr;</kbd> navigate
            </span>
            <span className="global-search-key-hint">
                <kbd>&crarr;</kbd> open
            </span>
            <span className="global-search-footer-status" role="status" aria-live="polite">
                {loading ? 'Searching...' : hasQuery ? `${totalResults} results` : null}
            </span>
        </div>
    )
}
